import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({selector: '[pinAutoFocus]'})
export class AutoFocusDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);

  ngAfterViewInit(): void {
    if (this.elementRef && this.elementRef.nativeElement) {
      const targetInput = this.elementRef.nativeElement;
      setTimeout(function () {
        targetInput.focus();
      }, 100);
    }
  }
}
